import { Component } from '@angular/core';

import {
    NavController,
    NavParams } from 'ionic-angular';

import { OrganizationStandings } from '../../model/organizationStandings';
import { RodeoEventStandings } from '../../model/rodeoEventStandings';

@Component({
    selector: 'page-org-standings',
    templateUrl: 'org-standings.html'
})
export class OrgStandingsPage {
    viewMode: any = 'all';
    orgStandings: OrganizationStandings;

    selectedRodeoEvent: RodeoEventStandings = new RodeoEventStandings();

    constructor(private nav : NavController, navParams : NavParams) {
        this.orgStandings = navParams.get('orgStandings');
        this.selectedRodeoEvent = this.orgStandings.rodeoEvents[0];
        console.log("selected: ", this.selectedRodeoEvent);
    }

    back() {
        this.nav.pop();
    }

    matchRodeoEvents(rodeoEventOne: RodeoEventStandings, rodeoEventTwo: RodeoEventStandings): boolean {
        return rodeoEventOne.eventType == rodeoEventTwo.eventType;
    }
}


// WEBPACK FOOTER //
// ./src/pages/standings/org-standings.ts